module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-3.cddf706b.png";